import React, {useState, useEffect} from 'react';
import {VisDiv, FieldDropdown} from '..';
import {useStateContext} from '../../context/StateContext';
import { addValueForDropdown, sortByLabel, sortByArrayElement} from '../../lib/utils'; 
import useMediaQuery from '../../hooks/useMediaQuery';
import { offerDocFromProductsAndList } from '../gestioneDatabase/Docs';
import { PinField } from './PinField';
import { groupedOffer } from './GroupedOffer';
import { isGodMode } from '../../lib/userPermissions';

export const GroupedPin = ({item, priceListItem, customBackgroundColour, allHidden, setItem, index, commonStyle, edit, offer, products, allProducts, setProduct, groupProducts}) => {
     
  const visibleLocations = !Array.isArray(groupProducts) ? [] : groupProducts?.filter?.((x)=>!x?.hide)?.map?.((pr)=>pr?.location)?.sort(sortByArrayElement)
  const viewOnlyItem = !Array.isArray(groupProducts) && groupProducts?.length < 1 ? undefined : groupedOffer(groupProducts)?.[0]
  
  //console.log("òdjvòosdcjòo", item, viewOnlyItem )
  const {client, sUser} = useStateContext()
  const manualAdd = item?.isManual
  const isLabour = item?.labourProduct
  const screenSizeDesktop = useMediaQuery("(min-width: 1540px)")

  const rowColour = edit ? "#FFF6DE" : index % 2 ? "white":"#f3f4f3"
  const isHidden = allHidden ? allHidden : item?.hide
  const hideTextColor =  isHidden ? {color:"#C0C0C0"} : {}

  const backgroundColour = () => {
    if(customBackgroundColour){
      return customBackgroundColour
    }
    return rowColour
  }

  const offerProducts = allProducts?.customerProducts?.map?.((item)=>{
   
    const product = item?.supplierProducts?.[0]
    const priceList = !Array.isArray(allProducts?.priceList?.products) ? undefined : allProducts?.priceList?.products?.find?.((x)=>x?.customerProduct?._ref == item?._id)
    //console.log("ITEM IN OFFER PRODUCTS", product, priceList)
    return offerDocFromProductsAndList(item, product, priceList, client)
  })

  const [loadedProduct, setLoadedProduct] = useState()
  useEffect(()=>{
    if(loadedProduct){
      setProduct(loadedProduct)
      console.log("SELECTED LOADED PRODUCT", loadedProduct) 
    }
  },[loadedProduct])
const testFunction = () => {
  console.log("sdlkcmsldkmcnTEST GROUPED PIN ",
    {
      
    }
  )
}

  return(
    <>
    <VisDiv rules={[isGodMode(sUser)]}> 
      <button onClick={testFunction}>
          TEST GROUPED PIN
      </button>
    </VisDiv>
    <VisDiv rules={[edit, item?.isManual]}>
      <FieldDropdown
            isMulti={false}
            isSearchable="isSearchable"
            //initialValue={client}
            placeHolder={"AGGIUNGI PRODOTTO"}
            options={addValueForDropdown(offerProducts)?.sort(sortByLabel)}
            onChange={(value) => {
              setLoadedProduct(value)
            }
            }
        />
    </VisDiv>
    <VisDiv rules={[edit]}>
      <GroupedHeader commonStyle={commonStyle} edit={edit} manualAdd={manualAdd} isLabour={isLabour}/>
    </VisDiv>
{/*     <button onClick={()=>console.log("all products", loadedProduct, item, "offer products", offerProducts, "all products", allProducts)} >test add product</button> */}
    <div style={{backgroundColor:backgroundColour(), display:"flex", ...hideTextColor}} >
      <VisDiv style={{...commonStyle(edit), textAlign:"center"}}>
        <PinField loadedProduct={loadedProduct} offer={offer} products={products} item={item} viewOnlyItem = {viewOnlyItem} setItem={setItem} edit={edit} objKey={"pricelistCode"} />
      </VisDiv>
      <VisDiv style={{...commonStyle(edit), flex:6, justifyContent:"left", minWidth: "185px"}}>
        <PinField loadedProduct={loadedProduct} offer={offer} products={products}  item={item} viewOnlyItem = {viewOnlyItem} setItem={setItem} edit={edit} objKey={"law"} richEditor={true}/>
      </VisDiv>
      <VisDiv style={{...commonStyle(edit), flex:6, justifyContent:"left", minWidth: "185px"}}>
        <PinField loadedProduct={loadedProduct} offer={offer} products={products} item={item} viewOnlyItem = {viewOnlyItem} setItem={setItem} edit={edit} objKey={"description"} richEditor={true}/>
      </VisDiv>
      <VisDiv rules={[!edit]} style={{...commonStyle(edit), flex:1.2, minWidth: "185px"}}>
        <PinField groupProducts={groupProducts} visibleLocations={visibleLocations} loadedProduct={loadedProduct} offer={offer} products={products} item={item} viewOnlyItem = {viewOnlyItem} setItem={setItem} fieldType={"textArea"} objKey={"location"} />
      </VisDiv>
      <VisDiv rules={[!edit]} style={{...commonStyle(edit)}}>
        <PinField loadedProduct={loadedProduct} offer={offer} products={products} item={item} viewOnlyItem = {viewOnlyItem} setItem={setItem} objKey={"quantity"} numberFormat={"twoDecimals"}/>
      </VisDiv>
      <VisDiv style={{...commonStyle(edit)}}>
        <PinField loadedProduct={loadedProduct} priceListItem={priceListItem} offer={offer} products={products} item={item} viewOnlyItem = {viewOnlyItem} setItem={setItem} edit={edit} objKey={"unitPrice"} numberFormat={"euro"} prefix={"€"}/>
      </VisDiv>
      <VisDiv style={{...commonStyle(edit)}}>
        <PinField loadedProduct={loadedProduct} offer={offer} products={products} item={item} viewOnlyItem = {viewOnlyItem} setItem={setItem} edit={edit} objKey={"discount"} numberFormat={"percentage"} suffix={"%"}/>
      </VisDiv>
      <VisDiv rules={[!edit]} style={{...commonStyle(edit)}}>
        <PinField loadedProduct={loadedProduct} offer={offer} products={products} item={item} viewOnlyItem = {viewOnlyItem} setItem={setItem} objKey={"discountedUnitPrice"} numberFormat={"euro"} prefix={"€"}/>
      </VisDiv>
      <VisDiv rules={[!edit]} style={{...commonStyle()}}>
        <PinField loadedProduct={loadedProduct} offer={offer} products={products} item={item} viewOnlyItem = {viewOnlyItem} setItem={setItem} objKey={"priceToClient"} numberFormat={"euro"} prefix={"€"}/> 
      </VisDiv>
      <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle(edit)}}>
        <PinField loadedProduct={loadedProduct} offer={offer} products={products} item={item} viewOnlyItem = {viewOnlyItem} setItem={setItem} edit={edit} objKey={"supplierPrice"} numberFormat={"euro"} prefix={"€"}/>
      </VisDiv>
      <VisDiv rules={[screenSizeDesktop, !edit]} style={{...commonStyle()}}>
        <PinField loadedProduct={loadedProduct} offer={offer} products={products} item={item} viewOnlyItem = {viewOnlyItem} setItem={setItem} objKey={"totalCost"} numberFormat={"euro"} prefix={"€"}/> 
      </VisDiv>
      <VisDiv rules={[screenSizeDesktop, !edit]} style={{...commonStyle()}}>
        <PinField loadedProduct={loadedProduct} offer={offer} products={products} item={item} viewOnlyItem = {viewOnlyItem} setItem={setItem} objKey={"margin"} numberFormat={"percentage"} suffix={"%"}/>
      </VisDiv>
      <VisDiv rules={[screenSizeDesktop, !edit]} style={{...commonStyle()}}>
        <PinField loadedProduct={loadedProduct} offer={offer} products={products} item={item} viewOnlyItem = {viewOnlyItem} setItem={setItem} objKey={"profit"} numberFormat={"euro"} prefix={"€"}/>
      </VisDiv>
      <VisDiv rules={[screenSizeDesktop, !edit]} style={{...commonStyle()}}>
        <PinField loadedProduct={loadedProduct} offer={offer} products={products} item={item} viewOnlyItem = {viewOnlyItem} setItem={setItem} objKey={"unitProfit"} numberFormat={"euro"} prefix={"€"}/>
      </VisDiv>
      <VisDiv rules={[false, screenSizeDesktop, !edit || isLabour]}  style={{...commonStyle(edit)}}>
        <PinField loadedProduct={loadedProduct} offer={offer} products={products} item={item} viewOnlyItem = {viewOnlyItem} setItem={setItem} edit={edit} objKey={"labourHours"}  numberFormat={"twoDecimals"}/>
      </VisDiv>
  </div>
  </>
  )
}

export const GroupedHeader = ({commonStyle, edit, manualAdd, isLabour}) => {
    const screenSizeDesktop = useMediaQuery("(min-width: 1540px)")
    return(
      <div style={{backgroundColor:"#385391", fontSize:"12px", fontWeight:"500", color:"white", display:"flex", }} >
        <VisDiv style={{...commonStyle(edit)}}>
          {"COD."}
        </VisDiv>
        <VisDiv style={{...commonStyle(edit), flex:6, justifyContent:"left", minWidth: "185px"}}>
          {"NORMATIVA DI RIFERIMENTO PER L'ADEMPIMENTO AGLI OBBLIGHI DEI PRESIDI ATTREZZATURE E SISTEMI"}
        </VisDiv>
        <VisDiv style={{...commonStyle(edit), flex:6, justifyContent:"left", minWidth: "185px"}}>
          {"DESCRIZIONE"}
        </VisDiv>
        <VisDiv rules={[!edit]} style={{...commonStyle(edit), flex:1.2, minWidth: "185px"}}>
          <span>
           {"UBICAZIONE"}
          </span>
        </VisDiv>
        <VisDiv rules={[!edit]} style={{...commonStyle(edit)}}>
          {"Q.TA’"}
        </VisDiv>
        <VisDiv style={{...commonStyle(edit)}}>
          {"PREZZO CAD."}
        </VisDiv>
        <VisDiv style={{...commonStyle(edit)}}>
          {"SCONTO %"}
        </VisDiv>
        <VisDiv rules={[!edit]} style={{...commonStyle(edit)}}>
          {"PREZZO CAD. SCONTATO"}
        </VisDiv>
        <VisDiv rules={[!edit]} style={{...commonStyle()}}>
          {"TOTALE"}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle(edit), backgroundColor:"red"}}>
          {"PREZZO FORNITORE"}
        </VisDiv>
        <VisDiv  rules={[screenSizeDesktop, !edit]} style={{...commonStyle(), backgroundColor:"red"}}>
          {"TOTALE COSTO"}
        </VisDiv>
        <VisDiv  rules={[screenSizeDesktop, !edit]} style={{...commonStyle(), backgroundColor:"red"}}>
          {"MARGINE"}
        </VisDiv>
        <VisDiv  rules={[screenSizeDesktop, !edit]} style={{...commonStyle(), backgroundColor:"red"}}>
          {"PROFITTO"}
        </VisDiv>
        <VisDiv  rules={[screenSizeDesktop, !edit]} style={{...commonStyle(), backgroundColor:"red"}}>
          {"PROFITTO CAD."}
        </VisDiv>
        <VisDiv  rules={[false, screenSizeDesktop, !edit || isLabour]} style={{...commonStyle(edit), backgroundColor:"red"}}>
          {"MANO D'OPERA"}
        </VisDiv>
    </div>
    )
  }